import { getRecommendedFabricId } from '../reducers/sewpats';
import * as types from './actionTypes';
import { selectFabric } from './cart';

export const selectSewpat = sewpatId => (
  {
    type: types.SEWPAT_SELECTED,
    sewpatId,
  }
);

export const setActiveSewpat = sewpatId => async (dispatch, getState) => {
    dispatch({
        type: types.SEWPAT_SETTED,
        sewpatId,
    });
    const state = getState();
    dispatch(
        {
            type: types.FABRIC_SELECTED,
            fabricId: getRecommendedFabricId(state),
        });
    return Promise.resolve(sewpatId);
};



// WEBPACK FOOTER //
// ./src/actions/sewpats.js